var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessOmniplayEventsCoreVue',{attrs:{"dateDimension":_vm.dateDimension}})
}
var staticRenderFns = []

export { render, staticRenderFns }